import {
  Button,
  ButtonProps,
  Flex,
  Heading,
  Text,
} from "@aws-amplify/ui-react";
import { MdAdd, MdRemove } from "react-icons/md";
import { PropsWithChildren, useEffect, useState } from "react";

function CircleButton({
  children,
  size = 40,
  ...buttonProps
}: PropsWithChildren<
  {
    size?: number;
    onClick: () => void;
  } & Pick<ButtonProps, "onClick" | "isDisabled">
>) {
  return (
    <Button
      variation="primary"
      borderRadius="50%"
      padding={4}
      width={size}
      height={size}
      display="flex"
      alignItems="center"
      justifyContent="center"
      {...buttonProps}
    >
      {children}
    </Button>
  );
}

export default function SmallStepperField({
  onChange,
  max = 3,
  defaultValue = 0,
  min = 0,
  label,
}: {
  label: string;
  min: number;
  max: number;
  defaultValue: number;
  onChange: (numberOfGuests: number) => void;
}) {
  const [value, setValue] = useState<number>(defaultValue);

  useEffect(() => {
    onChange(value);
  }, [value]);

  return (
    <>
      <Flex alignItems={"center"} justifyContent={"space-between"}>
        <Flex alignItems={"center"}>
          <Heading>{label}</Heading>

          <Text>{value}</Text>
        </Flex>
        <Flex>
          <CircleButton
            size={30}
            isDisabled={value <= min}
            onClick={() => {
              setValue(value - 1);
            }}
          >
            <MdRemove size={20} />
          </CircleButton>

          <CircleButton
            size={30}
            isDisabled={value >= max}
            onClick={() => {
              const newValue = value + 1;

              if (newValue <= max) {
                setValue(value + 1);
              }
            }}
          >
            <MdAdd size={40} />
          </CircleButton>
        </Flex>
      </Flex>
    </>
  );
}
